<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div v-if="canSee" class="vs-sidebar--item" :data-hash="hash" :data-remove="remove" :class="[
    { 'vs-sidebar-item-active': activeLink },
    { 'disabled-item pointer-events-none': isDisabled },
  ]">

    <template v-if="$route.name === 'menu-builder'">
      <!-- <router-link
        tabindex="-1"
        v-if="false !== false"
        :class="[{'cursorMove': cursorMove}]"
        :to="''"
        :target="target" >
          <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
          <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
          <slot />
      </router-link> -->

      <a :target="target" :href="'#'" tabindex="-1" :class="{ 'cursorMove': cursorMove }">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
        <slot />
      </a>
    </template>

    <template v-else>
      <!-- <router-link
        tabindex="-1"
        v-if="to"
        exact
        :class="[{'router-link-active': activeLink, 'cursorMove': cursorMove}]"
        :to="to"
        :target="target" >
          <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
          <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
          <slot />
      </router-link> -->
      <a :style="{ cursor: 'pointer' }" tabindex="-1" v-if="destinationTypeId === 6" :href="resolvedHref" target="_blank">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
        <slot />
      </a>
      <!-- :to="'https://google.com'" -->
      <router-link tabindex="-1" v-else-if="to" exact
        :class="[{ 'router-link-active': activeLink, 'cursorMove': cursorMove }]" :to="to" :target="target">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
        <slot />
      </router-link>

      <a v-else :target="target" :href="href" tabindex="-1" :class="{ 'cursorMove': cursorMove }">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
        <slot />
      </a>
    </template>
  </div>
</template>

<script>
import { resolveExternalMenuUrl } from "../../../helpers";

export default {
  name: 'v-nav-menu-item',
  props: {
    icon: { type: String, default: '' },
    iconSmall: { type: Boolean, default: false },
    iconPack: { type: String, default: 'material-icons' },
    href: { type: [String, null], default: '#' },
    to: { type: [String, Object, null], default: null },
    slug: { type: String, default: null },
    index: { type: [String, Number], default: null },
    featherIcon: { type: Boolean, default: true },
    target: { type: String, default: '_self' },
    isDisabled: { type: Boolean, default: false },
    cursorMove: { type: Boolean, default: false },
    actionButtons: { type: Boolean, default: false },
    hash: { type: String, default: '' },
    remove: { type: Boolean, default: false },
    destinationTypeId: { type: Number, default: 3 },
  },
  methods: {
    handleExternalMenuClick(url) {
      // console.log(url)
    },
    cancelClick() {
      return false
    },
    encryptUrl(a) {
      return btoa(a)
    }
  },
  computed: {
    resolvedHref() {
      if (this.destinationTypeId !== 6) {
        return this.to;
      }

      return resolveExternalMenuUrl(this.to);
    },
    canSee() {
      this.$acl.check(this.$store.state.AppActiveUser.userRole)
      return this.to ? this.$acl.check(this.$router.match(this.to).meta.rule) : true
    },
    activeLink() {
      if (this.$route.name === 'menu-builder') {
        return false
      } else {
        return !!((this.to === this.$route.path || this.$route.meta.parent === this.slug) && this.to)
      }
    }
  }
}

</script>
<style>
.cursorMove {
  cursor: move !important;
}
</style>
